import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { CoursesService } from '../../courses.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SelectCourseComponent } from '../select-course/select-course.component';
import { CheckoutModalService } from 'src/app/course/services/checkout-modal.service';

@Component({
  selector: 'app-course-group-card',
  templateUrl: './course-group-card.component.html',
  styleUrls: ['./course-group-card.component.scss']
})
export class CourseGroupCardComponent implements OnInit, OnDestroy {

  modalRef: BsModalRef;
  selectFromACourseGroup: any;
  sub: Subscription;

  @Input() courseGroup: any;
  @Input() purchased: boolean;

  constructor(
    private coursesService: CoursesService,
    private modalService: BsModalService,
    private router: Router,
    private checkoutModalService: CheckoutModalService
  ) {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  go() {
    if (this.courseGroup.primaryCourse) {
      // window.location = this.courseGroup.primaryCourse.courseUrl;
      //this.router.navigate(['/course', this.courseGroup.primaryCourse.webAppId]);
      this.coursesService.openCourse(this.courseGroup.primaryCourse, this.courseGroup.primaryCourse?.progress?.userCourse);
    } else {
      this.openModal();
    }
  }

  openCourse(course, userCourse?) {
    this.coursesService.openCourse(course, userCourse);
  }


  toggleFavorite($event) {

    if (this.courseGroup.primaryCourse.progress.userCourse == null) {
      this.coursesService.favorite(this.courseGroup.primaryCourse, true);
      this.courseGroup.primaryCourse.progress.userCourse = { favorite: true };
    } else if (this.courseGroup.primaryCourse.progress.userCourse != null) {
      this.courseGroup.primaryCourse.progress.userCourse.favorite = !this.courseGroup.primaryCourse.progress.userCourse.favorite;
      this.coursesService.favorite(this.courseGroup.primaryCourse, this.courseGroup.primaryCourse.progress.userCourse.favorite);
    }

  }

  openModal() {
    const initialState = {
      courseGroup: this.courseGroup,
      purchased: this.purchased
    };
    this.modalRef = this.modalService.show(SelectCourseComponent, { initialState, class: 'modal-lg rounded-modal' });
  }

  onBuyClick(event, course) {
    event.preventDefault();
    event.stopPropagation();

    this.checkoutModalService.buyCourse(course);
  }
}
